import Axios from 'axios'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    manualSync: false,
    manualSyncLoader: false,
    lastSyncDate: null,
    userTotalResponse: null,
    syncRoundNumber: null,
    roundFixtures: null,
    selectToggle: false,
    moveFixtureLoading: false,
    moveFixtureStatus: null,
    triggerMoveButton: false,
    roundPredictionTrack: null
  },
  getters: {
    MANUAL_SYNC_RESPONSE: state => state.manualSync,
    MANUAL_SYNC_RESPONSE_LOADER: state => state.manualSyncLoader,
    LAST_SYNC_DATE: state => state.lastSyncDate,
    USER_TOTAL: state => state.userTotalResponse,
    GET_SYNC_ROUND_NUMBER: state => state.syncRoundNumber,
    GET_ROUND_FIXTURES: state => state.roundFixtures,
    GET_SELECT_TOGGLE: state => state.selectToggle,
    GET_MOVE_FIXTURES_LOADING: state => state.moveFixtureLoading,
    GET_MOVE_FIXTURES_STATUS: state => state.moveFixtureStatus,
    GET_TRIGGER_MOVE_BUTTON: state => state.triggerMoveButton,
    GET_ROUND_PREDICTION_TRACK: state => state.roundPredictionTrack
  },
  mutations: {
    SET_MANUAL_SYNC_RESPONSE: (state, payload) => {
      state.manualSync = payload
    },
    SET_MANUAL_SYNC_RESPONSE_LOADER: (state, payload) => {
      state.manualSyncLoader = payload
    },
    SET_LAST_SYNC_DATE: (state, payload) => {
      state.lastSyncDate = payload
    },
    SET_USER_TOTAL: (state, payload) => {
      state.userTotalResponse = payload
    },
    SET_SYNC_ROUND_NUMBER: (state, payload) => {
      state.syncRoundNumber = payload
    },
    SET_ROUND_FIXTURES: (state, payload) => {
      state.roundFixtures = payload
    },
    SET_TOGGLE_SELECT: (state, payload) => {
      state.selectToggle = payload
    },
    SET_MOVE_FIXTURES_LOADING: (state, payload) => {
      state.moveFixtureLoading = payload
    },
    SET_MOVE_FIXTURES_STATUS: (state, payload) => {
      state.moveFixtureStatus = payload
    },
    SET_TRIGGER_MOVE_BUTTON: (state, payload) => {
      state.triggerMoveButton = payload
    },
    SET_ROUND_PREDICTION_TRACK: (state, payload) => {
      state.roundPredictionTrack = payload
    }
  },
  actions: {
    SYNC_FOOTBALL_DATA: async context => {
      try {
        context.commit('SET_MANUAL_SYNC_RESPONSE_LOADER', true)

        const response = await Axios.get('/admin/sync-data')
        context.commit('SET_MANUAL_SYNC_RESPONSE', response.data.success)
        const lastSyncDate = moment(response.data.data).format('lll')
        context.commit('SET_LAST_SYNC_DATE', lastSyncDate)
      } catch (error) {
        context.commit('SET_MANUAL_SYNC_RESPONSE', error.response.data)
      } finally {
        context.commit('SET_MANUAL_SYNC_RESPONSE_LOADER', false)
      }
    },
    FETCH_LAST_SYNC_DATE: async context => {
      try {
        const response = await Axios.get(`/admin/last-sync`)
        const lastSyncDate = response.data.data
          ? moment(response.data.data).format('lll')
          : 'Not yet synced'
        context.commit('SET_LAST_SYNC_DATE', lastSyncDate)
      } catch (error) {
        context.commit('SET_LAST_SYNC_DATE', error.response.data)
      }
    },
    FETCH_USER_TOTAL: async context => {
      try {
        const response = await Axios.get('/admin/total-user')
        context.commit('SET_USER_TOTAL', response.data)
      } catch (error) {
        context.commit('SET_USER_TOTAL', error.response.data)
      }
    },
    SYNC_ROUND_NUMBER: async (context, payload) => {
      try {
        context.commit('SET_MANUAL_SYNC_RESPONSE_LOADER', true)

        const response = await Axios.post('/admin/sync-round', payload)
        context.commit('SET_SYNC_ROUND_NUMBER', response.data)
        context.commit('SET_MANUAL_SYNC_RESPONSE', response.data.success)
      } catch (error) {
        context.commit('SET_SYNC_ROUND_NUMBER', error.response.data)
      } finally {
        context.commit('SET_MANUAL_SYNC_RESPONSE_LOADER', false)
      }
    },
    FETCH_ROUND_FIXTURES: async (context, payload) => {
      try {
        const response = await Axios.get(`/football/fixtures/round/${payload}`)
        context.commit('SET_ROUND_FIXTURES', response.data)
      } catch (error) {
        context.commit('SET_ROUND_FIXTURES', error.response.data)
      }
    },
    TOGGLE_SELECT: async (context, payload) => {
      context.commit('SET_TOGGLE_SELECT', payload)
    },
    MOVE_FIXTURES: async (context, payload) => {
      try {
        context.commit('SET_MOVE_FIXTURES_LOADING', true)

        const response = await Axios.post('/football/move-fixtures', payload)
        context.commit('SET_MOVE_FIXTURES_STATUS', response.data)
      } catch (error) {
        context.commit('SET_MOVE_FIXTURES_STATUS', error.response.data)
      } finally {
        context.commit('SET_MOVE_FIXTURES_LOADING', false)
      }
    },
    FETCH_ROUND_PREDICTION_TRACK: async (context, payload) => {
      try {
        const { data: response } = await Axios.get(
          `/admin/track-prediction/round/${payload}`
        )
        context.commit('SET_ROUND_PREDICTION_TRACK', response.data)
      } catch (error) {
        context.commit('SET_ROUND_PREDICTION_TRACK', error.response.data)
      }
    }
  }
}
